// extracted by mini-css-extract-plugin
module.exports = {"idle-time-in-percentage":"style_idle-time-in-percentage__3nKni"};